module.exports = __webpack_public_path__ + "img/peru_awajun_04.b51ffbcb.png";